var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{ref:"threeContainer",staticStyle:{"position":"fixed","margin":"auto 0","z-index":"3","inset":"0","width":"100%","height":"100%"},attrs:{"id":"threeContainer"}})}
var staticRenderFns = []

export { render, staticRenderFns }